import { zipCodeError, ZipCodeResponse } from './types';

type zipCodeApi = (_zipCode: string) => Promise<ZipCodeResponse>

export const fetchZipCode: zipCodeApi = async zipCode => {
    try {
        const response = await fetch(
            `/api/v1/city_addresses/search?postal_code=${zipCode}`
        );
        return await response.json();
    } catch (error) {
        throw zipCodeError(error.message);
    }
};
